import React, { useEffect, useState } from 'react';
import "./Products.css";
import Slider from 'react-slick';

function Products () {
    let [ mobile, setMobile ] = useState( false );

    let settings = {
        dots: false,
        infinite: true,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: false
    };

    useEffect( () => {
        window.scrollTo( 0, 0 );
        if ( document.getElementById( "root" ).clientWidth < 600 ) {
            setMobile( true );
        }
    }, [] );

    return (
        <div className='products-container'>
            <div className='products-banner'>
                {!mobile && <img src={require( "../../images/products/banner.avif" )} alt="product-banner" height={"100%"} width={"100%"} />}
                {mobile && <img src={require( "../../images/products/banner-mobile.avif" )} alt="product-banner" height={"100%"} width={"100%"} />}
                <div className='products-banner-content'>
                    <span>Our Products</span>
                    <span>Precision-engineered fasteners for secure, reliable, and high-performance applications in aerospace and beyond.</span>
                </div>
            </div>
            <div className='products-middle'>
                At Aero Fasteners, we offer a comprehensive range of precision-engineered products. Whether for commercial or military use, trust Aero Fasteners to provide secure and durable solutions for all your critical aerospace needs.
            </div>
            {!mobile && <div className='landing-products-list'>
                <div className='landing-product'>
                    <img src={"https://media.istockphoto.com/id/1193517707/photo/many-small-bolts-and-nuts-by-manufacturing-process-in-factory.jpg?s=2048x2048&w=is&k=20&c=iKqX4-O-FpbRArNXru8uLwmxQlQUHVobKsP8TBGH3nU="} alt="product 1" height={"100%"} width={"100%"} />
                    {/* <img src={require( "../../images/landing/products/nuts.avif" )} alt="product 1" height={"100%"} width={"100%"} /> */}
                    <div></div>
                    <div>Nuts</div>
                </div>
                <div className='landing-product'>
                    <img src={"https://media.istockphoto.com/id/629625452/photo/hose-clamp.jpg?s=2048x2048&w=is&k=20&c=hhzuyYsDC00K-HD7bLqr51XlgYPKDQFuveuYb1PEJTY="} alt="product 1" height={"100%"} width={"100%"} />
                    {/* <img src={require( "../../images/landing/products/washers.avif" )} alt="product 1" height={"100%"} width={"100%"} /> */}
                    <div></div>
                    <div>Washers & Circlips</div>
                </div>
                <div className='landing-product'>
                    <img src={require( "../../images/landing/products/captive_screws.avif" )} alt="product 1" height={"100%"} width={"100%"} />
                    <div></div>
                    <div>Captive Screws</div>
                </div>
                <div className='landing-product'>
                    <img src={require( "../../images/landing/products/socket.avif" )} alt="product 1" height={"100%"} width={"100%"} />
                    <div></div>
                    <div>Socket & Torx Head Screws</div>
                </div>
                <div className='landing-product'>
                    <img src={require( "../../images/landing/products/machine.avif" )} alt="product 1" height={"100%"} width={"100%"} />
                    <div></div>
                    <div>Machine Screws</div>
                </div>
                <div className='landing-product'>
                    <img src={require( "../../images/landing/products/hex.avif" )} alt="product 1" height={"100%"} width={"100%"} />
                    <div></div>
                    <div>Hex Head Screws</div>
                </div>
                <div className='landing-product'>
                    <img src={require( "../../images/landing/products/set_screws.avif" )} alt="product 1" height={"100%"} width={"100%"} />
                    <div></div>
                    <div>Set Screws / Grub Screws</div>
                </div>
                <div className='landing-product'>
                    <img src={require( "../../images/landing/products/taptite_screws.avif" )} alt="product 1" height={"100%"} width={"100%"} />
                    <div></div>
                    <div>Taptite Thread Forming Screws</div>
                </div>
                <div className='landing-product'>
                    <img src={require( "../../images/landing/products/self_tapping.avif" )} alt="product 1" height={"100%"} width={"100%"} />
                    <div></div>
                    <div>Self Tapping Screws</div>
                </div>
                <div className='landing-product'>
                    <img src={require( "../../images/landing/products/rivets.avif" )} alt="product 1" height={"100%"} width={"100%"} />
                    <div></div>
                    <div>Rivets & Eyelets</div>
                </div>
                <div className='landing-product'>
                    <img src={require( "../../images/landing/products/dowels.avif" )} alt="product 1" height={"100%"} width={"100%"} />
                    <div></div>
                    <div>Dowels, Pins & Inserts</div>
                </div>
            </div>}
            {mobile && <Slider {...settings} className='products-slider'>
                <div className='landing-product'>
                    <img src={"https://media.istockphoto.com/id/1193517707/photo/many-small-bolts-and-nuts-by-manufacturing-process-in-factory.jpg?s=2048x2048&w=is&k=20&c=iKqX4-O-FpbRArNXru8uLwmxQlQUHVobKsP8TBGH3nU="} alt="product 1" height={"100%"} width={"100%"} />
                    {/* <img src={require( "../../images/landing/products/nuts.avif" )} alt="product 1" height={"100%"} width={"100%"} /> */}
                    <div></div>
                    <div>Nuts</div>
                </div>
                <div className='landing-product'>
                    <img src={"https://media.istockphoto.com/id/629625452/photo/hose-clamp.jpg?s=2048x2048&w=is&k=20&c=hhzuyYsDC00K-HD7bLqr51XlgYPKDQFuveuYb1PEJTY="} alt="product 1" height={"100%"} width={"100%"} />
                    {/* <img src={require( "../../images/landing/products/washers.avif" )} alt="product 1" height={"100%"} width={"100%"} /> */}
                    <div></div>
                    <div>Washers & Circlips</div>
                </div>
                <div className='landing-product'>
                    <img src={require( "../../images/landing/products/captive_screws.avif" )} alt="product 1" height={"100%"} width={"100%"} />
                    <div></div>
                    <div>Captive Screws</div>
                </div>
                <div className='landing-product'>
                    <img src={require( "../../images/landing/products/socket.avif" )} alt="product 1" height={"100%"} width={"100%"} />
                    <div></div>
                    <div>Socket & Torx Head Screws</div>
                </div>
                <div className='landing-product'>
                    <img src={require( "../../images/landing/products/machine.avif" )} alt="product 1" height={"100%"} width={"100%"} />
                    <div></div>
                    <div>Machine Screws</div>
                </div>
                <div className='landing-product'>
                    <img src={require( "../../images/landing/products/hex.avif" )} alt="product 1" height={"100%"} width={"100%"} />
                    <div></div>
                    <div>Hex Head Screws</div>
                </div>
                <div className='landing-product'>
                    <img src={require( "../../images/landing/products/set_screws.avif" )} alt="product 1" height={"100%"} width={"100%"} />
                    <div></div>
                    <div>Set Screws / Grub Screws</div>
                </div>
                <div className='landing-product'>
                    <img src={require( "../../images/landing/products/taptite_screws.avif" )} alt="product 1" height={"100%"} width={"100%"} />
                    <div></div>
                    <div>Taptite Thread Forming Screws</div>
                </div>
                <div className='landing-product'>
                    <img src={require( "../../images/landing/products/self_tapping.avif" )} alt="product 1" height={"100%"} width={"100%"} />
                    <div></div>
                    <div>Self Tapping Screws</div>
                </div>
                <div className='landing-product'>
                    <img src={require( "../../images/landing/products/rivets.avif" )} alt="product 1" height={"100%"} width={"100%"} />
                    <div></div>
                    <div>Rivets & Eyelets</div>
                </div>
                <div className='landing-product'>
                    <img src={require( "../../images/landing/products/dowels.avif" )} alt="product 1" height={"100%"} width={"100%"} />
                    <div></div>
                    <div>Dowels, Pins & Inserts</div>
                </div>
            </Slider>}
        </div>
    )
}

export default Products
